"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AnonymousIP {
    constructor(response) {
        this.ipAddress = response.ip_address;
        this.isAnonymous = !!response.is_anonymous;
        this.isAnonymousVpn = !!response.is_anonymous_vpn;
        this.isHostingProvider = !!response.is_hosting_provider;
        this.isPublicProxy = !!response.is_public_proxy;
        this.isResidentialProxy = !!response.is_residential_proxy;
        this.isTorExitNode = !!response.is_tor_exit_node;
    }
}
exports.default = AnonymousIP;
